import { IonContent } from '@ionic/react';
import React from 'react';

import { CircularProgress } from '@/components/CircularProgress';
import { UiTypography } from '@/components/ui/Typography';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';

import { PageStyles, PageTitleStyles, SubtitleStyles } from './Progress.styles';

interface ProgressScreenProps {
  progress: number;
  startProgress?: number;
  backgroundImage: string;
  topTitle: string;
  mainTitle: string;
  subtitle: string;
  buttonText: string;
}

export const ProgressScreen: React.FC<ProgressScreenProps> = ({
  progress,
  startProgress = 0,
  backgroundImage,
  topTitle,
  mainTitle,
  subtitle,
  buttonText,
}) => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles backgroundImage={backgroundImage} background={'dark-solid'}>
      <div className="progress-container">
        <CircularProgress
          progress={progress}
          startProgress={startProgress}
          size={282}
          strokeWidth={36}
        />
      </div>

      <IonContent>
        <OnboardingNavigation />
        <PageTitleStyles
          className="top-title"
          component="h1"
          variant="title-medium"
          align="center"
        >
          {topTitle}
        </PageTitleStyles>
        <div className="content-wrapper">
          <PageTitleStyles
            className="page-title"
            component="h1"
            variant="title-medium"
            align="center"
          >
            {mainTitle}
            <SubtitleStyles>{subtitle}</SubtitleStyles>
          </PageTitleStyles>
          <OnboardingFooter
            buttonSize="large"
            buttonRadius="md"
            onContinue={handleNextStep}
            buttonText={buttonText}
          />
        </div>
      </IonContent>
    </PageStyles>
  );
};
